import { render, staticRenderFns } from "./RevenueHistoryChart.vue?vue&type=template&id=505b3a27"
import script from "./RevenueHistoryChart.vue?vue&type=script&lang=js"
export * from "./RevenueHistoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports